type Props = {
  children: string;
};

const ErrorMessage = ({ children }: Props) => (
  <div className="py-2 text-red-500">{children}</div>
);

export default ErrorMessage;
